import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import messages from '../../../data/products';
import AnalyticsClient from '../../../clients/AnalyticsClient';
import productEvents from '../../../analytics/events/products';

import './PaperPicker.scss';

/**
 * Entry point for Paper Picker functionality on a tile
 */

class PaperPickerComponent extends React.Component {
  buildEditPaperTextOrLink() {
    const { paperOption, isEditable, isDisabled, url, urlEdit } = this.props;
    const editPaperText = this.context.intl.formatMessage(messages.editPaperType);
    const editText = this.context.intl.formatMessage(messages.tileMenuEditTooltip);

    if (isEditable) {
      return isDisabled ? (
        <span>
          <span
            className="paperpicker-component__anchor--desktopViewport u-fontFamily-primaryMedium"
            data-edit-link="editable-paper-link-desktop"
          >
            {editPaperText}
          </span>
          <span
            className="paperpicker-component__anchor--mobileViewport u-fontFamily-primaryMedium"
            data-edit-link="editable-paper-link-mobile"
          >
            {editText}
          </span>
        </span>
      ) : (
        <span>
          <a
            className="paperpicker-component__anchor--desktopViewport u-fontFamily-primaryMedium"
            onClick={() => AnalyticsClient.trackEvent(productEvents.paperPicker(paperOption))}
            href={url}
            data-edit-link="editable-paper-link-desktop"
          >
            {editPaperText}
          </a>
          <a
            className="paperpicker-component__anchor--mobileViewport u-fontFamily-primaryMedium"
            onClick={() => AnalyticsClient.trackEvent(productEvents.tileAction('Mobile Edit'))}
            href={urlEdit}
            data-edit-link="editable-paper-link-mobile"
          >
            {editText}
          </a>
        </span>
      );
    }

    return (
      <span
        className="paperpicker-component__anchor paperpicker-component__anchor--hidden u-fontFamily-primaryMedium"
        data-edit-link="disabled-edit-text"
      >
        {editPaperText}
      </span>
    );
  }

  render() {
    return (
      <span className="paperpicker-component u-fontFamily-secondary">
        {` x ${this.props.paperOption}. `}
        {this.props.url && <span className="paperpicker-component__link">{this.buildEditPaperTextOrLink()}</span>}
      </span>
    );
  }
}

PaperPickerComponent.displayName = 'PaperPicker';

PaperPickerComponent.propTypes = {
  isEditable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  paperOption: PropTypes.string.isRequired,
  url: PropTypes.string,
  urlEdit: PropTypes.string,
};

PaperPickerComponent.defaultProps = {
  isEditable: true,
  isDisabled: false,
};

PaperPickerComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default PaperPickerComponent;
